<template>
  <div>
    <h3>{{ popupData.title }}</h3>
    <h4>{{ popupData.place.locality }}</h4>
    <div>{{ popupData.place.function }}</div>
    <div>{{ popupData.shon | formatIntNumber }} m<sup>2</sup></div>
    <div>{{ popupData.place.ownershipStatus }}</div>
    <div>{{ popupData.nbAreas }}</div>
    <h4>{{ popupData.year }}</h4>
    <div>Consommation {{ popupData.primaryEnergyConsumption | formatIntNumber }} kWhEP</div>
    <div>Dépenses {{ popupData.totalCost | formatIntNumber }} €</div>
    <div class="footer">
      <md-button
        :to="{ name: 'Building stock site buildings', params: { siteId: popupData.place.id }}"
        class="md-button md-raised">
        Détails
      </md-button>
    </div>
  </div>
</template>

<script>
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'

export default {
  name: 'BuildingStockPopup',
  mixins: [ValuesDisplayMixin],
  data () {
    return {}
  },
  props: {
    popupData: {
      type: Object,
      required: true,
      default: function () {
        return {
          title: '',
          place: {
            id: null,
            locality: '',
            function: '',
            ownershipStatus: ''
          },
          shon: 0,
          nbAreas: 0,
          year: 0,
          primaryEnergyConsumption: 0,
          totalCost: 0
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BuildingStockPopup.vue